import React from "react";
import OptimizedImage from "hooks/OptimizedImage";

function QuoteCard() {
  return (
    <div className="w-full flex items-center justify-center bg-white py-3 pb-6 sm:pb-3 px-4 mt-4 lg:mt-10 flex-col sm:flex-row">
      <div className="w-full flex flex-col sm:pl-6 pt-3 sm:pt-0 text-center sm:text-left">
        <p className="font-secondary text-2xl text-midBlue font-semibold mb-2">Do you need help getting a quote ?</p>
        <h2 className="font-secondary text-sm sm:text-lg text-midBlue">Contact us and we'll get you sorted out</h2>
      </div>
      <div className="w-full flex items-center justify-center  lg:flex-row flex-row sm:flex-col mt-5 sm:mt-0 gap-[10px]">
        <OptimizedImage src="https://tomedes.gumlet.io/assets/images/MaskGroup.png" alt="loading..." className="w-24 h-24 mr-2 rounded-full" style={{ borderRadius: "100%" }} />
        <div>
          <p className="hidden sm:block text-darkBlue font-secondary font-semibold text-lg">
            <span className="text-orange">David Hart</span> - Account Manager
          </p>
          <p className="sm:hidden text-darkBlue font-secondary font-semibold text-lg">
            <span className="text-orange">David Hart</span> -
            <br />
            Account Manager
          </p>
          <h2 className="hidden sm:block font-secondary text-[#667495] text-sm pt-2 pb-1">US: +1 985 239 0142 | UK: +44 1615 096140</h2>
          <h2 className="sm:hidden font-secondary text-[#667495] text-sm py-2">
            US: +1 985 239 0142 |
            <br />
            UK: +44 1615 096140
          </h2>
          <p className="font-secondary text-[#667495] text-sm">support@tomedes.com</p>
        </div>
      </div>
    </div>
  );
}

export default QuoteCard;
